/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { calendarEventSchema } from './calendar-event-schema';
import { opportunitySchema } from './opportunity-schema';
import { MeetingLinkType } from "../enums";

export const calendarEventConversationSchema: z.AnyZodObject = z.object({
  cancelled: z.boolean(),
  clientToSalesEventId: z.string().nullish(),
  clientToTsEventId: z.string().nullish(),
  createdAt: z.string().datetime().nullish(),
  editRevision: z.number().int(),
  endTime: z.string().datetime().nullish(),
  events: z.array(z.lazy(() => calendarEventSchema)).nullish(),
  followUpEmailSentAt: z.string().datetime().nullish(),
  id: z.string().uuid(),
  meetingLinkType: z.nativeEnum(MeetingLinkType).nullish(),
  opportunity: z.lazy(() => opportunitySchema).nullish(),
  opportunityId: z.string().uuid().nullish(),
  startTime: z.string().datetime().nullish(),
  talentToSalesEventId: z.string().nullish(),
  talentToTsEventId: z.string().nullish(),
  unavailableAlertSentAt: z.string().datetime().nullish(),
  updatedAt: z.string().datetime().nullish(),
});

export type CalendarEventConversation = z.infer<typeof calendarEventConversationSchema>;
